module.exports = __webpack_public_path__ + "fonts/trust_sans_medium-webfont.6f282f37.woff";